function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import { readContext } from '../context';
import memoize from '../utils/memoize';
import shallowEqual from '../utils/shallow-equal';

var Subscriber =
/*#__PURE__*/
function (_Component) {
  _inherits(Subscriber, _Component);

  _createClass(Subscriber, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // Get fresh state at every re-render, so if a parent triggers
      // a re-render before the component subscription calls onUpdate()
      // we already serve the updated state and skip the additional render
      var nextStoreStateValue = prevState.getStoreStateValue(nextProps, true);
      return {
        storeStateValue: nextStoreStateValue
      };
    }
  }]);

  function Subscriber(_props) {
    var _this;

    _classCallCheck(this, Subscriber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Subscriber).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "store", null);

    _defineProperty(_assertThisInitialized(_this), "subscription", null);

    _defineProperty(_assertThisInitialized(_this), "selector", _this.constructor.selector && memoize(_this.constructor.selector));

    _defineProperty(_assertThisInitialized(_this), "getStoreStateValue", function () {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      var fromContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // eslint-disable-next-line no-unused-vars

      var children = nextProps.children,
          props = _objectWithoutProperties(nextProps, ["children"]); // We can get stores from context ONLY during rendering phase
      // overwise React will return the default ctx value!


      _this.store = fromContext ? _this.getStoreFromContext() : _this.store;

      var currentStoreState = _this.store.storeState.getState();

      return _this.selector ? _this.selector(currentStoreState, props) : _this.selector === null ? undefined : currentStoreState;
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (updState, forceUpdate) {
      // Ensure component is still mounted and has a store attached
      if (!_this.store) return;
      var prevStoreStateValue = _this.state.storeStateValue;

      var nextStoreStateValue = _this.getStoreStateValue(); // Only update if state changed or if container triggered


      if (!shallowEqual(prevStoreStateValue, nextStoreStateValue) || forceUpdate) {
        // nextState will recalculated by gDSFP anyway
        _this.setState({
          storeStateValue: nextStoreStateValue
        });
      }
    });

    _this.state = {
      storeStateValue: undefined,
      // stored to make them available in getDerivedStateFromProps
      // as js context there is null https://github.com/facebook/react/issues/12612
      getStoreStateValue: _this.getStoreStateValue
    };
    return _this;
  }

  _createClass(Subscriber, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // As suggested by the async docs, we add listener after mount
      // So it won't leak if mount is interrupted or errors
      // https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
      this.subscribeToUpdates(); // Moreover, when async render, state could change between render and mount
      // so to ensure state is fresh we should manually call onUpdate and
      // potentially causing a de-opts to synchronous rendering (should be rare)
      // https://github.com/facebook/react/issues/13186#issuecomment-403959161

      this.onUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // ensure subscription is still to the correct store
      // as parent scope might change between renders
      this.subscribeToUpdates();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.store = null;

      if (this.subscription) {
        this.subscription.remove();
        this.subscription = null;
      }
    }
  }, {
    key: "getStoreFromContext",
    value: function getStoreFromContext() {
      var storeType = this.constructor.storeType; // We use React context just to get the stores registry
      // then we rely on our internal pub/sub to get updates
      // because context API doesn't have builtin selectors (yet).

      var ctx = readContext();
      return ctx.getStore(storeType);
    }
  }, {
    key: "subscribeToUpdates",
    value: function subscribeToUpdates() {
      var storeState = this.store.storeState; // in case store has been recreated during an update (due to scope change)

      if (this.subscription && this.subscription.storeState !== storeState) {
        this.subscription.remove();
        this.subscription = null;
      }

      if (!this.subscription) {
        this.subscription = {
          storeState: storeState,
          remove: storeState.subscribe(this.onUpdate)
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      // this is needed for compat with React<16.5
      // as gDSFP in not called before first render
      var storeStateValue = this.store ? this.state.storeStateValue : this.getStoreStateValue(this.props, true);
      return this.props.children(storeStateValue, this.store.actions);
    }
  }]);

  return Subscriber;
}(Component);

_defineProperty(Subscriber, "propTypes", {
  children: PropTypes.func.isRequired
});

_defineProperty(Subscriber, "storeType", null);

_defineProperty(Subscriber, "selector", void 0);

export { Subscriber as default };